export default "__VITE_ASSET__d9MnfiOr__"